import { LogoutOutlined } from '@ant-design/icons';
import { App, Button } from 'antd';
import { useLogoutMutation } from '@/entities/user';

export function LogoutButton() {
  const { modal } = App.useApp();
  const [logout, { isLoading }] = useLogoutMutation();

  const handleClick = () => {
    modal.confirm({
      title: 'Выйти из аккаунта?',
      onOk: () => {
        void logout();
      },
    });
  };

  return (
    <Button type="text" icon={<LogoutOutlined />} loading={isLoading} onClick={handleClick}>
      Выйти
    </Button>
  );
}
